export default "__VITE_PUBLIC_ASSET__79a8b41f__"